<template>
  <div class="order-form-wrapper">
    <div class="order-head cleared">
      <div class="order-head__flex ft-lt cleared">
        <div class="left_head">
          <div class="order-num ft-lt">
            📊 Детальный рейтинг: {{ managerName }}
          </div>
          <div class="s-and-a ft-lt">
            <div class="order-sum">
              <div class="s-and-a__discr gray italic">За период</div>
              <div class="value">
                <input type="date" v-model="dateFrom" class="date-input" style="width: 140px;" />
                <span style="margin: 0 8px;">—</span>
                <input type="date" v-model="dateTo" class="date-input" style="width: 140px;" />
                <button @click="fetchStats" class="btn btn-primary small" style="margin-left: 12px;">Показать</button>
              </div>
            </div>
          </div>
        </div>
        <div class="right_head">
          <button class="btn btn-secondary small" @click="$router.back()">← Назад</button>
        </div>
      </div>
    </div>

    <div class="m-box">
      <div class="inside">
        <div v-if="statsByDay.length > 1" class="best-stats-section">
          <h3 class="section-title">🏆 Лучшие показатели</h3>
          <div class="stats-grid">
            <div class="stats-card">
              <div class="stats-card-header"><h4>📦 Больше всего заказов</h4></div>
              <div class="stats-card-content">
                <span class="stat-label">Дата:</span>
                <span class="stat-value">{{ bestOrders.date }} ({{ getWeekdayShort(bestOrders.date) }})</span>
                <span class="stat-label">Количество:</span>
                <span class="stat-value">{{ bestOrders.value }}</span>
              </div>
            </div>
            <div class="stats-card">
              <div class="stats-card-header"><h4>📊 Лучшая конверсия</h4></div>
              <div class="stats-card-content">
                <span class="stat-label">Дата:</span>
                <span class="stat-value">{{ bestConversion.date }} ({{ getWeekdayShort(bestConversion.date) }})</span>
                <span class="stat-label">Конверсия:</span>
                <span class="stat-value">{{ bestConversion.value.toFixed(1) }}%</span>
              </div>
            </div>
            <div class="stats-card">
              <div class="stats-card-header"><h4>💰 Самый большой бонус</h4></div>
              <div class="stats-card-content">
                <span class="stat-label">Дата:</span>
                <span class="stat-value">{{ bestBonus.date }} ({{ getWeekdayShort(bestBonus.date) }})</span>
                <span class="stat-label">Бонус:</span>
                <span class="stat-value">{{ bestBonus.value.toFixed(2) }}</span>
              </div>
            </div>
          </div>
        </div>

        <table class="modern-table">
          <thead>
            <tr>
              <th @click="setSort('date')" class="sortable">Дата <span class="weekday">(день)</span> <span v-if="sortKey==='date'">{{ sortDesc ? '▼' : '▲' }}</span></th>
              <th @click="setSort('totalOrders')" class="sortable">Заказов всего <span v-if="sortKey==='totalOrders'">{{ sortDesc ? '▼' : '▲' }}</span></th>
              <th @click="setSort('successfulOrders')" class="sortable">Успешных <span v-if="sortKey==='successfulOrders'">{{ sortDesc ? '▼' : '▲' }}</span></th>
              <th @click="setSort('canceledOrders')" class="sortable">Отменено <span v-if="sortKey==='canceledOrders'">{{ sortDesc ? '▼' : '▲' }}</span></th>
              <th @click="setSort('bonus')" class="sortable">Бонус <span v-if="sortKey==='bonus'">{{ sortDesc ? '▼' : '▲' }}</span></th>
              <th @click="setSort('averageBonus')" class="sortable">Средний бонус <span v-if="sortKey==='averageBonus'">{{ sortDesc ? '▼' : '▲' }}</span></th>
              <th @click="setSort('conversion')" class="sortable">Конверсия (%) <span v-if="sortKey==='conversion'">{{ sortDesc ? '▼' : '▲' }}</span></th>
              <th @click="setSort('efficiency')" class="sortable">Эффективность <span v-if="sortKey==='efficiency'">{{ sortDesc ? '▼' : '▲' }}</span></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in sortedStatsByDay" :key="row.date">
              <td>{{ row.date }} ({{ getWeekdayShort(row.date) }})</td>
              <td>{{ row.totalOrders }}</td>
              <td>{{ row.successfulOrders }}</td>
              <td>{{ row.canceledOrders }}</td>
              <td>{{ row.bonus.toFixed(2) }}</td>
              <td>{{ row.averageBonus.toFixed(2) }}</td>
              <td>{{ row.conversion.toFixed(1) }}</td>
              <td>{{ row.efficiency.toFixed(1) }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr style="font-weight: bold; background: #f3f6fa;">
              <td>Итого</td>
              <td>{{ totalOrders }}</td>
              <td>{{ totalSuccessfulOrders }}</td>
              <td>{{ totalCanceledOrders }}</td>
              <td>{{ totalBonus.toFixed(2) }}</td>
              <td>{{ avgBonus.toFixed(2) }}</td>
              <td>{{ avgConversion.toFixed(1) }}</td>
              <td>{{ avgEfficiency.toFixed(1) }}</td>
            </tr>
          </tfoot>
        </table>
        <div v-if="!statsByDay.length" class="no-data">Нет данных за выбранный период</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ORDERS_API_BASE } from '@/config/api';
import axios from 'axios';

export default {
  name: 'ManagerRatingDetails',
  data() {
    const today = new Date().toISOString().slice(0, 10);
    return {
      dateFrom: today,
      dateTo: today,
      statsByDay: [],
      managerName: '',
      loading: false,
      error: '',
      managerId: null,
      managers: [], // список менеджеров
      // Списки статусов как в ManagerRating.vue
      cancellationStatuses: [
        'kontrol-vozvratr-magazin', 'kfhdlfhgkfldfofuglfdlidfhgfdgjlfklghldfk', '7kontrol-otmena', '876h-hk-kjhkj', '15k-usljsd-sl', 'cancel-other',
        'delyvery-did-not-suit', 'otmenasdoskdfjdkfj', 'otmenasdostavk', 'otmena-s-otgruzkoi-kureru', 'otmena-sotgruz-kupil', 'otmena-vozim-by', 'send-to-assembling', 'otmena-nashel-konkurentov',
        'kdjfffffff8hjf', 'klkhdshjlsd88sdfsdf898', 'kiuhhjsdsdkkkkkkk12', 'pod-zakaz', 'dffddsdfsdd'
      ],
      successfulStatuses: [
        'assembling', 'assembling-complete', '4-komplektuetsya-sklad-sharangovicha-kurer-2',
        '3-komplektuetsya-sklad-sharangovicha-kurer-1', 'ktuetsya-sklad-sharangovicha-kur234234ggg',
        'jdhfjfhjdhfjdhfdfhhhhhhhhhhhhh', '8-komplektuetsia-sklad-karvata-kurer-8',
        '7-komplektuetsia-sklad-karvata-kurer-7', '10-komplektuetsia-sklad-karvata-kurer-10',
        '9-komplektuetsia-sklad-karvata-kurer-9', 'send-to-delivery', 'redirect', 'fdjkdfkljd',
        'dskjdslksd', 'zakaz-dostavlen-kur', '1-zakaz-kurerom-dostavlen-dengi-i-bu-sdany',
        'fdkjsdkjdsklkl1', 'korrektirovka-zakaza', 'dsfssffsds', 'kushddflsidudhy', 'offer-analog', 
        'nelvvhs47ujgt', 'kontrolhgcfxhg', 'kontrol-vozvrat-na-sklad', '12kontrol-obmen'
      ],
      excludedBonusStatuses: [

        'cancel-other', 'otmena-s-otgruzkoi-kureru', 'otmena-vozim-by',
        'povregden-tovar-piidostavke', 'delyvery-did-not-suit', 'otmenasdostavk',
        'prodaza-chastichnaya-sostoyalas', 'otmena-dubl', 'obmen-s-doplatiu',
        'kiuhhjsdsdkkkkkkk12', 'otmenaskomentom', 'klkhdshjlsd88sdfsdf898',
        'kdjfffffff8hjf', 'khkhhjgsdlgtij6', 'send-to-assembling',
        'otmenasdoskdfjdkfj', 'otmena-kupil-u-dr-mened', 'otmena-sotgruz-kupil',
        'otmena-nashel-konkurentov', 'otmenasvozvratomvmagazin', '5blsdfhoisdhflkdshf',
        'otmena-magas-mesto-man', 'otmena-s-necelevoi', 'kldjfdfdfsdfsdfdfffffffffffffff',
     
        'new', 'availability-confirmed', 'sdilsddkls', 'lskdjslkklsk', 'dffddsdfsdd',
        'offer-analog', 'maslosto', 'vzial-v-rabotu', 'sdlkfsdjfsdfsdf-sdfgsdf-sdf',
        'pod-zakaz', 'novyi-beznalnyi-klient',
        '1-priniat-na-proverku-sostavleny-vse-bumagi-postavil-na-zariadku',
        '2a-akb-zariadilsia-klienta-uvedomil-zhdu-ego-vizita',
        '2b-ne-zariadilsia-klienta-uvedomil-zhdu-ego-vizita-sniat-s-garantii',
        '3-1-s-karvata-peredali-na-mashinostroitelei-servis',
        '3-1-s-karvata-peredali-postavshchiku-importioru-ne-nasha-akb',
        '3-2-s-mashinostroitelei-servis-peredali-na-karvata',
        '4-otkaz-net-braka-budet-vozvrat-klientu',
        '0-vopros-uregulirovan-klient-bolshe-ne-bespokoit',
        '0-neobkhodim-otvet-na-pretenziiu', '0-otvet-otpravlen-potrebiteliu',
        '6-postavshchik-vernul-nam-novyi-akb-vmesto-braka',
        '3-2-ot-postavshchika-peredali-na-karvata',
        '4-brak-podtverzhdion-soglasovyvaetsia-zamena-klienta-opovestil',
        '2g-ne-zariadilsia-klienta-uvedomil-chto-peredaiu-na-minsk-vozmozhno-brak',
        '5-vydan-pokupateliu-novyi-akb-документы-подписаны-вопрос-закрыт',
        '5-вydan-obratno-ego-zhe-akb-ne-zariadilsia-сниат-с-гарантии',
        'ili-dengi-dokumenty-podpisany',
        '2-vopros-uregulirovan-v-magazine-vozvrashchion-klientu-zariazhennym',
        'sto-prodazaza', 'stoffnksajn12212', 'avto-v-remonte-v-tsekhu', 'stowfifdk2j',
        'gotov-k-vydache', 'prokonsultirovan-perezvonit-pozzhe',
        'neobkhodimo-perezvonit-klientu-zapchasti-tseny-perechen-rabot-sto',
        '5-avto-vydan-klientu'
      ],
      sortKey: 'date',
      sortDesc: false,
    };
  },
  computed: {
    bestOrders() {
      if (!this.statsByDay.length) return { date: '', value: 0 };
      const max = this.statsByDay.reduce((a, b) => a.totalOrders > b.totalOrders ? a : b);
      return { date: max.date, value: max.totalOrders };
    },
    bestConversion() {
      if (!this.statsByDay.length) return { date: '', value: 0 };
      const max = this.statsByDay.reduce((a, b) => a.conversion > b.conversion ? a : b);
      return { date: max.date, value: max.conversion };
    },
    bestBonus() {
      if (!this.statsByDay.length) return { date: '', value: 0 };
      const max = this.statsByDay.reduce((a, b) => a.bonus > b.bonus ? a : b);
      return { date: max.date, value: max.bonus };
    },
    sortedStatsByDay() {
      const arr = [...this.statsByDay];
      arr.sort((a, b) => {
        let aVal = a[this.sortKey];
        let bVal = b[this.sortKey];
        if (typeof aVal === 'string' && this.sortKey === 'date') {
          return this.sortDesc ? bVal.localeCompare(aVal) : aVal.localeCompare(bVal);
        }
        if (typeof aVal === 'string') {
          aVal = parseFloat(aVal.replace(',', '.'));
          bVal = parseFloat(bVal.replace(',', '.'));
        }
        if (aVal < bVal) return this.sortDesc ? 1 : -1;
        if (aVal > bVal) return this.sortDesc ? -1 : 1;
        return 0;
      });
      return arr;
    },
    totalOrders() {
      return this.statsByDay.reduce((sum, row) => sum + row.totalOrders, 0);
    },
    totalSuccessfulOrders() {
      return this.statsByDay.reduce((sum, row) => sum + row.successfulOrders, 0);
    },
    totalCanceledOrders() {
      return this.statsByDay.reduce((sum, row) => sum + row.canceledOrders, 0);
    },
    totalBonus() {
      return this.statsByDay.reduce((sum, row) => sum + row.bonus, 0);
    },
    avgBonus() {
      const filtered = this.statsByDay.filter(row => row.base >= 1);
      const totalBase = filtered.reduce((sum, row) => sum + row.base, 0);
      const totalBonus = filtered.reduce((sum, row) => sum + row.bonus, 0);
      return totalBase > 0 ? totalBonus / totalBase : 0;
    },
    avgConversion() {
      const totalSuccess = this.totalSuccessfulOrders;
      const totalCancel = this.totalCanceledOrders;
      const base = totalSuccess + totalCancel;
      return base > 0 ? (totalSuccess / base) * 100 : 0;
    },
    avgEfficiency() {
      const filtered = this.statsByDay.filter(row => row.base >= 1);
      return filtered.length > 0 ? filtered.reduce((sum, row) => sum + row.efficiency, 0) / filtered.length : 0;
    },
  },
  created() {
    this.managerId = this.$route.params.managerId;
    this.fetchManagersAndStats();
  },
  methods: {
    async fetchManagersAndStats() {
      try {
        const res = await axios.get(ORDERS_API_BASE + '/managers.php');
        if (Array.isArray(res.data)) {
          this.managers = res.data.map(m => ({ id: m.value, label: m.label }));
        }
      } catch (e) {
        this.managers = [];
      }
      this.fetchManagerName();
      this.fetchStats();
    },
    fetchManagerName() {
      this.managerName = this.getManagerLabel(this.managerId);
    },
    getManagerLabel(managerId) {
      const m = this.managers.find(x => String(x.id) === String(managerId));
      return m ? m.label : `Менеджер ${managerId}`;
    },
    async fetchStats() {
      this.loading = true;
      this.error = '';
      let allOrders = [];
      let page = 1;
      const perPage = 100;
      try {
        while (true) {
          const params = {
            'filter[managers][in][]': this.managerId,
            'filter[createdAt][gte]': this.dateFrom,
            'filter[createdAt][lte]': this.dateTo,
            'per_page': perPage,
            'page': page
          };
          const res = await axios.get(ORDERS_API_BASE + '/orders.php', { params });
          if (res.data && Array.isArray(res.data.orders)) {
            allOrders = allOrders.concat(res.data.orders);
          }
          if (!res.data.pagination || page >= res.data.pagination.totalPageCount) break;
          page++;
        }
        // Группировка по дням
        const daysMap = {};
        allOrders.forEach(order => {
          const date = order.createdAt ? order.createdAt.slice(0, 10) : 'нет даты';
          if (!daysMap[date]) {
            daysMap[date] = {
              date,
              totalOrders: 0,
              successfulOrders: 0,
              canceledOrders: 0,
              bonus: 0,
              bonusOrdersCount: 0
            };
          }
          daysMap[date].totalOrders++;
          if (this.successfulStatuses.includes(order.status)) daysMap[date].successfulOrders++;
          if (this.cancellationStatuses.includes(order.status)) daysMap[date].canceledOrders++;
          // Бонусы
          if (!this.excludedBonusStatuses.includes(order.status)) {
            const bonusRaw = order.customFields && order.customFields.dfhgodsf8g7 ? order.customFields.dfhgodsf8g7 : '0';
            const bonus = parseFloat((bonusRaw + '').replace(',', '.'));
            if (!isNaN(bonus)) {
              daysMap[date].bonus += bonus;
              daysMap[date].bonusOrdersCount++;
            }
          }
        });
        // Формируем массив и считаем средние/конверсию/эффективность
        this.statsByDay = Object.values(daysMap).sort((a, b) => a.date.localeCompare(b.date)).map(row => {
          const base = row.successfulOrders + row.canceledOrders;
          const averageBonus = base > 0 ? row.bonus / base : 0;
          const conversion = base > 0 ? (row.successfulOrders / base) * 100 : 0;
          const efficiency = (conversion * 0.3) + (averageBonus * 0.2);
          return {
            ...row,
            averageBonus,
            conversion,
            efficiency,
            base
          };
        });
      } catch (e) {
        this.error = 'Ошибка загрузки данных: ' + (e.message || e);
        this.statsByDay = [];
      } finally {
        this.loading = false;
      }
    },
    setSort(key) {
      if (this.sortKey === key) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortKey = key;
        this.sortDesc = false;
      }
    },
    getWeekdayShort(dateStr) {
      if (!dateStr) return '';
      const days = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
      const d = new Date(dateStr);
      if (isNaN(d)) return '';
      return days[d.getDay()];
    },
  },
};
</script>

<style scoped>
/* Стили скопированы из ManagerRating.vue для единого дизайна */
.order-form-wrapper {
  font-family: 'Segoe UI', sans-serif;
  background: #f8f9fb;
  width: 100%;
}
.order-head {
  padding: 32px 0 24px;
}
.order-head__flex {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
}
.order-head > div {
  color: #1e2248;
  font-size: 12px;
  width: 100%;
}
.order-num {
  font-size: 24px;
  font-weight: 500;
  color: #1e2248;
}
.s-and-a {
  font-size: 12px;
  line-height: 14px;
  margin: 0 0 0 24px;
}
.s-and-a__discr {
  color: #636f7f !important;
  font-style: normal !important;
}
.s-and-a .value {
  font-weight: 600;
  color: #1e2248;
  font-size: 14px;
  line-height: 20px;
}
.m-box {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-top: 24px;
}
.inside {
  padding: 32px;
}
.modern-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 16px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.modern-table thead {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
}
.modern-table th {
  padding: 16px 20px;
  font-weight: 600;
  font-size: 14px;
  text-align: left;
  border: none;
}
.modern-table td {
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
  font-size: 14px;
  color: #1e2248;
  text-align: center;
}
.modern-table tr:hover {
  background-color: #f8f9fa;
}
.modern-table tr:last-child td {
  border-bottom: none;
}
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}
.stats-card {
  background: #fff;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.stats-card-header h4 {
  margin: 0 0 16px 0;
  color: #1e2248;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 8px;
}
.stats-card-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.stat-label {
  color: #636f7f;
  font-size: 13px;
}
.stat-value {
  font-weight: 600;
  font-size: 14px;
  color: #1e2248;
}
.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.btn-primary {
  background: #0078d7;
  color: #fff;
}
.btn-primary:hover {
  background: #106ebe;
  transform: translateY(-1px);
}
.btn.small {
  padding: 6px 12px;
  font-size: 13px;
}
.btn-secondary {
  background: #6c757d;
  color: #fff;
}
.btn-secondary:hover {
  background: #5a6268;
  transform: translateY(-1px);
}
.no-data {
  text-align: center;
  color: #636f7f;
  font-size: 16px;
  padding: 32px 0;
}
.sortable {
  cursor: pointer;
  user-select: none;
  position: relative;
}
.weekday {
  color: #888;
  font-size: 12px;
  font-style: italic;
  margin-left: 2px;
}
</style> 